(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vy-classic-bangle-purchase"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.vy-purchase').forEach(panel=>{panel.addEventListener('change',event=>{const choice=event.target;if(!choice.matches('input[data-vy-asin]'))return;panel.querySelector('[data-vy-current-price]').textContent=choice.dataset.vyPrice;panel.querySelector('[data-vy-amazon]').href='https://www.amazon.co.jp/dp/'+choice.dataset.vyAsin+'?m=A3O2UFX5H2Y40M&th=1';});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vy-curve-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const choice = event.target;
  if (!(choice instanceof HTMLInputElement) || !choice.matches('.vy-curve input[data-vy-asin]')) return;
  const panel = choice.closest('.vy-curve');
  const form = panel.querySelector('product-form form');
  const available = choice.dataset.vyAvailable === 'true';
  panel.querySelector('[data-vy-current-price]').textContent = choice.dataset.vyPrice;
  panel.querySelector('[data-vy-amazon]').href = 'https://www.amazon.co.jp/dp/' + choice.dataset.vyAsin + '?m=A3O2UFX5H2Y40M&th=1';
  if (!form) return;
  const input = form.querySelector('input[name="id"]');
  input.value = choice.value;
  input.disabled = !available;
  const button = form.querySelector('button[name="add"]');
  button.disabled = !available;
  button.removeAttribute('aria-disabled');
  button.querySelector('span').textContent = available ? panel.dataset.vyAddText : panel.dataset.vySoldOutText;
  const error = panel.querySelector('.product-form__error-message-wrapper');
  if (error) error.hidden = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vy-direct-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const choice = event.target;
  if (!(choice instanceof HTMLInputElement) || !choice.matches('.vy-purchase input[data-vy-asin]')) return;
  const panel = choice.closest('.vy-purchase');
  const form = panel.querySelector('product-form form');
  const available = choice.dataset.vyAvailable === 'true';
  panel.querySelector('[data-vy-current-price]').textContent = choice.dataset.vyPrice;
  panel.querySelector('[data-vy-amazon]').href = 'https://www.amazon.co.jp/dp/' + choice.dataset.vyAsin + '?m=A3O2UFX5H2Y40M&th=1';
  if (!form) return;
  const input = form.querySelector('input[name="id"]');
  input.value = choice.value;
  input.disabled = !available;
  const button = form.querySelector('button[name="add"]');
  button.disabled = !available;
  button.removeAttribute('aria-disabled');
  button.querySelector('span').textContent = available ? panel.dataset.vyAddText : panel.dataset.vySoldOutText;
  const error = panel.querySelector('.product-form__error-message-wrapper');
  if (error) error.hidden = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vy-purchase-ready"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.vy-purchase').forEach(panel=>{panel.addEventListener('change',event=>{const choice=event.target;if(!choice.matches('input[data-vy-asin]'))return;panel.querySelector('[data-vy-current-price]').textContent=choice.dataset.vyPrice;panel.querySelector('[data-vy-amazon]').href='https://www.amazon.co.jp/dp/'+choice.dataset.vyAsin+'?m=A3O2UFX5H2Y40M&th=1';});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vy-snow-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
 const choice=event.target;
 if(!(choice instanceof HTMLInputElement)||!choice.matches('.vy-snow input[data-snow-option]'))return;
 const panel=choice.closest('.vy-snow');
 const design=panel.querySelector('[data-snow-option="design"]:checked')?.value;
 const variantsForSizes=JSON.parse(panel.querySelector('[data-snow-variants]').textContent);
 const sizeInputs=Array.from(panel.querySelectorAll('[data-snow-option="size"]'));
 sizeInputs.forEach(input=>{const exists=variantsForSizes.some(v=>v.design===design&&v.size===input.value);input.closest('label').hidden=!exists;input.disabled=!exists;});
 if(!sizeInputs.some(input=>input.checked&&!input.disabled)){const first=sizeInputs.find(input=>!input.disabled);if(first)first.checked=true;}
 const size=panel.querySelector('[data-snow-option="size"]:checked')?.value;
 const variants=JSON.parse(panel.querySelector('[data-snow-variants]').textContent);
 const variant=variants.find(v=>v.design===design&&v.size===size);
 if(!variant)return;
 panel.querySelector('[data-snow-price]').textContent=variant.price;
 const form=panel.querySelector('product-form form');
 if(!form)return;
 const id=form.querySelector('input[name="id"]');
 id.value=variant.id;
 id.disabled=!variant.available;
 const button=form.querySelector('button[name="add"]');
 button.disabled=!variant.available;
 button.removeAttribute('aria-disabled');
 button.querySelector('span').textContent=variant.available?panel.dataset.addText:panel.dataset.soldText;
 const error=panel.querySelector('.product-form__error-message-wrapper');
 if(error)error.hidden=true;
});
function vyInitGemstoneSizes(){
 document.querySelectorAll('.vy-snow').forEach(panel=>{
 const design=panel.querySelector('[data-snow-option="design"]:checked')?.value;
 const variants=JSON.parse(panel.querySelector('[data-snow-variants]').textContent);
 panel.querySelectorAll('[data-snow-option="size"]').forEach(input=>{
 const exists=variants.some(v=>v.design===design&&v.size===input.value);
 input.closest('label').hidden=!exists;input.disabled=!exists;
 });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',vyInitGemstoneSizes);else vyInitGemstoneSizes();
document.addEventListener('shopify:section:load',vyInitGemstoneSizes);
  } catch(e) { console.error(e); }
})();

})();
